export const zIndices = {
  '-1': -1,
  '1': 1,
  '2': 2,
  '3': 3,
  header: 10,
}
